export default __webpack_public_path__ + "static/media/settings-sharp.702892ba.svg";